import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrganisationAddStoreCreditPage } from 'src/app/modals/organisation-add-store-credit/organisation-add-store-credit.page';

const routes: Routes = [
  {
    path: '',
    component: OrganisationAddStoreCreditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrganisationAddStoreCreditPage]
})
export class OrganisationAddStoreCreditPageModule {}
